import Styles from './styles.module.scss';

import type { TaskModel } from '../../model/types/task.model';

interface Props {
	item: TaskModel;
}

export const Status = ({ item }: Props) => {
	return <span className={Styles.status}>{item.status}</span>;
};
